import { Button, Checkbox, Input, Link, Text } from '@viapeople/components'
import { useForm } from 'react-hook-form'
import image from '/login-man-working.png'
import viapeopleLogo from '/logo-grayscale.png'
import { beginLogin } from './authHelpers'

const Logo = () => (
	<div className='flex justify-center mb-15'>
		<img src={viapeopleLogo} alt='Via People Logo' className='h-15' />
	</div>
)

const DecorativeBackground = () => {
	return (
		<div className='flex flex-col items-center justify-between'>
			<div className='bg-neutral-100 mt-[-40px] h-[21%] aspect-[2/1] w-auto rounded-b-full' />
			<div className='absolute hidden md:inline w-[100%] aspect-[1/1] right-[45%] xl:right-[40%] top-[50%] lg:top-[45%] border border-primary-100 rounded-full' />
			<div className='self-end z-10 h-[73%] hidden md:flex'>
				<img src={image} alt='' className='h-full object-contain object-bottom' />
			</div>
		</div>
	)
}

interface LoginFormValues {
	email: string
	rememberMe: boolean
}

const LoginForm = () => {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<LoginFormValues>({
		defaultValues: {
			email: '',
			rememberMe: false,
		},
	})

	const onSubmit = (data: LoginFormValues) => {
		beginLogin(data.email.trim(), data.rememberMe)
	}

	return (
		<div className='flex flex-col w-full px-5 md:max-w-[360px] md:mr-[1rem] lg:max-w-[440px] justify-center'>
			<Logo />
			<Text variant='h3'>Please log in</Text>
			<form onSubmit={handleSubmit(onSubmit)}>
				<div className='mt-5 mb-6'>
					<Input
						label='Email'
						placeholder='Enter your email'
						isRequired
						hint={errors.email?.message}
						{...register('email', {
							required: 'Email is required',
							setValueAs: (v: string) => v.trim(),
							pattern: {
								value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
								message: 'Invalid email address',
							},
						})}
					/>
				</div>
				<div className='mb-6'>
					<Checkbox label='Remember me' {...register('rememberMe')} />
				</div>
				<Button type='submit' variant='primary' className='w-full'>
					Login
				</Button>
			</form>
			<div className='text-center mt-8'>
				<Text>
					Problems? <Link href='#'>Verify your browser capabilities</Link>
				</Text>
			</div>
		</div>
	)
}

export function LoginPage() {
	return (
		<main className='flex md:flex-row md:items-stretch h-dvh justify-center flex-col items-center relative overflow-hidden'>
			<DecorativeBackground />
			<LoginForm />
		</main>
	)
}
